import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import './AppHeader.scss';
import logo from '../../../assets/fysLogo.png'; // 导入 logo 图片
import UserDropdownMenu from './components/UserDropdownMenu.js';

const AppHeader = () => {
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);

  // 点击外部时关闭菜单
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleUserClick = () => {
    setShowMenu(!showMenu);
  };

  const handleNavigateToHome = () => {
    navigate('/');
  };

  const companyName = sessionStorage.getItem('companyName');
  const role_id = Number(sessionStorage.getItem('role_id'));

  return (
    <header>
      <nav className="VideoHeader">
        <div className="logo-container">
          <img src={logo} alt="Logo" className="logo-image" />
          <div
            className="header-title-container"
            onClick={handleNavigateToHome}
          >
            <h2 className="title">AI告别追思会</h2>
          </div>
        </div>
        {companyName && (
            <div className="user-menu-container" ref={menuRef}>
              <Button
                className="btn btn-primary custom-button"
                onClick={handleUserClick}
              >
                {companyName}
              </Button>

              {showMenu && <UserDropdownMenu role_id={role_id} onClose={() => setShowMenu(false)} />}
            </div>
        )}
      </nav>
    </header>
  );
};

export default AppHeader;
